import React, { useContext } from "react";
import "./LeftFilter.css";
import { ProductContext } from "../../Contexts/ProductContext";
import { PriceRangeSlider } from "./PriceRangeSlider";
import { MultiSelectFilter } from "./MultiSelectFilter";
import CateogoryFilterComponent from "./CateogoryFilterComponent";
import { ItemCondtion, sortByPrice } from "../../Utils/constant";
import { BsFilter, BsX } from "react-icons/bs";
import { isEmpty } from "../../Utils/utils";

const LeftSideFilter = () => {
  const { productState, productDispatch, filtersState, filtersDispatch,
    showFilters, toggleShowFilters, getMaxMinPriceFilter,
    handleProductFilter } =
    useContext(ProductContext);

  console.log("LeftSideFilter rerender", productState?.maxMinPrice, filtersState);

  const sameMinMaxPrice = (productState?.maxMinPrice?.max ?? 0) === (productState?.maxMinPrice?.min ?? 0);

  function sortProductsByPrice(products, sortType) {
    const sortedProducts = [...products];

    const result = sortedProducts.sort((a, b) => {
      const priceA = a?.bigPrice?.productmrPrice ?? 0;
      const priceB = b?.bigPrice?.productmrPrice ?? 0;

      if (sortType === "asc") {
        return priceA - priceB;
      } else if (sortType === "desc") {
        return priceB - priceA;
      } else {
        return 0;
      }
    });
    return result;
  }


  return (
    <div className="left-side-filter">
      {/* <button
        onClick={() => setIsOpen(!isOpen)}
        className="filter-toggle-btn"
      >
        {isOpen ? "Close" : "Open"}
      </button> */}

      {/* Filter Sidebar */}
      <div className={`filter-sidebar ${showFilters ? "open" : ""}`}>
        {showFilters && (
          <div className="filter-content">
            <div className="filters-head">
              <p><><BsFilter onPointerDown={() => toggleShowFilters()} /></>Filters</p>
              <button onClick={() => {
                const listCatgId = (filtersState?.categoryFilter ?? []).map(item => item?._id).filter(Boolean)
                getMaxMinPriceFilter(listCatgId);
                productDispatch({ type: "setProducts", payload: productState?.originalProducts ?? [] });
                filtersDispatch({ type: "setClear" });
              }} className="clear-btn">
                Clear
              </button>
              <BsX size={30} color="black" onPointerDown={() => toggleShowFilters()} />
            </div>
            <ul>
              {
                !sameMinMaxPrice &&
                <li><div className="filter-box">
                  <h3>Price</h3>
                  <PriceRangeSlider
                    filtersState={filtersState}
                    productDispatch={productDispatch}
                    productState={productState}
                    maxMinPrice={productState?.maxMinPrice}
                    filtersDispatch={filtersDispatch}
                  />
                </div></li>
              }
              {
                !sameMinMaxPrice &&
                <li><div className="filter-box">
                  <h3>Sort by Price</h3>
                  {sortByPrice?.map(({ label, value }) => (
                    <label key={value} className="price-box">
                      <input
                        type="radio"
                        value={value}
                        name="sortByPrice"
                        checked={filtersState?.sortByPriceFilter === value}
                        onChange={(e) => {
                          const sortType = e.target.value;
                          filtersDispatch({ type: "setSortByPriceFilter", payload: sortType });
                          if (!isEmpty(sortType)) {
                            productDispatch({ type: "setProducts", payload: sortProductsByPrice(productState?.originalProducts ?? [], e.target.value) });
                          }

                        }}
                      />
                      {label}
                    </label>
                  ))}
                </div></li>
              }
              <li><div className="filter-box">
                <h3>Brand</h3>
                <MultiSelectFilter
                  initialBrands={filtersState?.brandFilter || []}
                  filtersDispatch={filtersDispatch} />
              </div></li>
              {
                productState?.categories?.length > 0 && (
                  <li><div className="filter-box">
                    <h3>Category</h3>
                    <CateogoryFilterComponent
                      initialCateogoryFilter={filtersState?.categoryFilter || []}
                      listData={productState?.categories}
                      filtersDispatch={filtersDispatch}
                    />
                  </div></li>
                )
              }

              <li><div className="filter-box">
                <h3>Sort by Conditions</h3>
                {ItemCondtion?.map(({ label }, index) => (
                  <label key={index} className="price-box">
                    <input
                      type="radio"
                      value={label}
                      name="filterConditions"
                      checked={filtersState?.filterConditions === label}
                      onChange={(e) =>
                        filtersDispatch({ type: "setFilterConditionFilter", payload: e.target.value })
                      }
                    />
                    {label}
                  </label>
                ))}
              </div></li>
              {Array.isArray(productState?.listPersons) && productState?.listPersons.length > 0 && (
                <li><div className="filter-box">
                  <h3>Gender</h3>
                  {productState?.listPersons.map((label, index) => (
                    <label key={index} className="price-box">
                      <input
                        type="radio"
                        value={label}
                        name="personType"
                        checked={filtersState?.filterListPersons === label}
                        onChange={(e) =>
                          filtersDispatch({ type: "setPersonTypeFilter", payload: e.target.value })
                        }
                      />
                      {label}
                    </label>
                  ))}
                </div></li>
              )}
              {Array.isArray(productState?.listMovementType) &&
                productState?.listMovementType.length > 0 && (
                  <li><div className="filter-box">
                    <h3>Movement Type</h3>
                    {productState?.listMovementType.map((label, index) => (
                      <label key={index} className="price-box">
                        <input
                          type="radio"
                          value={label}
                          name="movementType"
                          checked={filtersState?.filterListMovementType === label}
                          onChange={(e) =>
                            filtersDispatch({ type: "setMovementTypeFilter", payload: e.target.value })
                          }
                        />
                        {label}
                      </label>
                    ))}
                  </div></li>
                )}
            </ul>
          </div>
        )}
        {
          showFilters && (<button className="apply-filter-button" onPointerDown={() => handleProductFilter()}>
            Apply Filter
          </button>)
        }
      </div>

    </div>
  );
};

export { LeftSideFilter };